import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import bankingInfoOnlyReducer from './bankingInfoOnlyForm/data/reducer';
import bankingInfoOnlySaga from './bankingInfoOnlyForm/data/sagas';
import * as materialWidget from './materialWidget/index';

const reducer = combineReducers({
  bankingInfoOnlyForm: bankingInfoOnlyReducer,
  materialWidget: materialWidget.reducer,
});

const saga = function* () {
  yield all([bankingInfoOnlySaga(), materialWidget.saga()]);
};

export { reducer, saga };
